export class OclResult {
    constructor(namesOfFailedInvs, evaluatedContexts) {
        this.namesOfFailedInvs = namesOfFailedInvs;
        this.evaluatedContexts = evaluatedContexts;
        this.result = namesOfFailedInvs.length === 0;
    }
    getResult() {
        return this.result;
    }
    getNamesOfFailedInvs() {
        return this.namesOfFailedInvs;
    }
    getEvaluatedContexts() {
        return this.evaluatedContexts;
    }
}
//# sourceMappingURL=OclResult.js.map